import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const API = 'https://blaketechnologiessite.onrender.com/auth';

export default function PasswordReset({ reset = false }) {
    const [token] = useState(() => new URLSearchParams(window.location.hash.slice(1)).get('token') || '');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmation, setConfirmation] = useState('');
    const [busy, setBusy] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [complete, setComplete] = useState(false);

    async function submit(event) {
        event.preventDefault();
        setError('');
        setMessage('');
        if (reset && password !== confirmation) {
            setError('Your passwords do not match.');
            return;
        }
        setBusy(true);
        try {
            const response = await axios.post(`${API}/${reset ? 'reset-password' : 'forgot-password'}`,
                reset ? { token, password } : { email: email.trim() });
            setMessage(response.data.message);
            setComplete(true);
            if (reset) {
                setPassword('');
                setConfirmation('');
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                window.history.replaceState(null, '', window.location.pathname);
            }
        } catch (err) {
            const data = err.response?.data;
            setError((data?.errMsg || 'Unable to reach the server. Please try again.') + (data?.requestId ? ` Reference: ${data.requestId}` : ''));
        } finally {
            setBusy(false);
        }
    }

    const inputClass = 'p-3 rounded-xl border w-full';
    return (
        <section className="min-h-screen flex items-center justify-center px-5">
            <div className="bg-gray-100 rounded-2xl shadow-lg w-full max-w-md p-8 text-[#002D74]">
                <h1 className="font-bold text-2xl">{reset ? 'Choose a new password' : 'Forgot your password?'}</h1>
                <p className="text-sm mt-3 mb-6">{reset ? 'Choose a password with at least 12 characters.' : 'Enter your account email and we’ll send you a link to reset your password.'}</p>
                {message && <p role="status" className="mb-5">{message}</p>}
                {error && <p role="alert" className="text-red-700 mb-5">{error}</p>}
                {reset && !token && <p role="alert" className="mb-5">This reset link is missing its token. Request a new link below.</p>}
                {!complete && (!reset || token) && <form onSubmit={submit} className="flex flex-col gap-4">
                    {reset ? <>
                        <label htmlFor="new-password">New password</label>
                        <input id="new-password" className={inputClass} type="password" autoComplete="new-password" minLength={12} required value={password} onChange={e => setPassword(e.target.value)} />
                        <label htmlFor="confirm-password">Confirm new password</label>
                        <input id="confirm-password" className={inputClass} type="password" autoComplete="new-password" minLength={12} required value={confirmation} onChange={e => setConfirmation(e.target.value)} />
                    </> : <>
                        <label htmlFor="reset-email">Email address</label>
                        <input id="reset-email" className={inputClass} type="email" autoComplete="email" maxLength={254} required value={email} onChange={e => setEmail(e.target.value)} />
                    </>}
                    <button disabled={busy} className="bg-[#002D74] text-white rounded-xl py-3 disabled:opacity-50">{busy ? 'Please wait…' : reset ? 'Reset password' : 'Send reset link'}</button>
                </form>}
                {reset && !complete && <Link className="block underline mt-5" to="/forgot-password">Request a new reset link</Link>}
                {/* A full navigation clears any existing in-memory login state. */}
                <a className="block underline mt-5" href="/login">Back to login</a>
            </div>
        </section>
    );
}
